Edit contact
<template>
  <x-dialog
    width="50%"
    dialogTitle="User Profile"
    :data-test-id="dataTestId"
    :dialogState="editContactDialog"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: updateContacts,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Save changes'
    }"
  >
    <template slot="dialog_data">
      <v-card-text class="px-8">
        <p v-if="!contacts.length">
          No contacts found. Click the button below to create contacts.
        </p>
        <v-tabs
          v-model="currentTab"
          background-color="transparent"
          grow
          v-if="contacts.length"
          slider-color="#58E2C2"
        >
          <v-tabs-slider color="#58E2C2"></v-tabs-slider>
          <v-tab
            v-for="(contact, index) in contacts"
            :key="index"
            :href="`#tab-${index}`"
            :data-test-id="`${dataTestId}__tab-${index + 1}`"
          >
            Contact {{ index + 1 }}
            <v-btn
              icon
              small
              class="close-icon"
              :data-test-id="`${dataTestId}__tab-${index + 1}__close-icon`"
              @click="removeContact(index)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-tab>
          <v-tab-item
            :value="`tab-${index}`"
            v-for="(contact, index) in contacts"
            :key="index"
            :data-test-id="`${dataTestId}__tab-item-${index + 1}`"
          >
            <v-card flat>
              <v-container>
                <v-form ref="form" lazy-validation v-model="contactForm">
                  <v-row align="center">
                    <v-col md="3" sm="12">
                      <label class="formInputLabel">Contact Type</label>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    no-gutters
                    :data-test-id="
                      `${dataTestId}__tab-item-${index +
                        1}__contact-type-input-wrapper`
                    "
                  >
                    <v-text-field
                      solo
                      dense
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model="contact.contactName"
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" sm="12">
                      <label class="formInputLabel">Email</label>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    no-gutters
                    :data-test-id="
                      `${dataTestId}__tab-item-${index +
                        1}__email-input-wrapper`
                    "
                  >
                    <v-text-field
                      ref="email1"
                      solo
                      dense
                      flat
                      height="52px"
                      background-color="#E5E5E5"
                      v-model="contact.email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-row>
                  <v-row align="center">
                    <v-col md="3" sm="12">
                      <label class="formInputLabel">Telephone:</label>
                    </v-col>
                  </v-row>
                  <v-row align="center" no-gutters>
                    <vue-tel-input
                      v-model="contact.telePhone"
                      v-bind="bindProps"
                      :class="telClass"
                      :data-test-id="
                        `${dataTestId}__tab-item-${index +
                          1}__tel-input-wrapper`
                      "
                      @validate="validatePhoneNumber($event, index)"
                    ></vue-tel-input>
                  </v-row>
                </v-form>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <v-row align="center" no-gutters class="ml-4 mt-2 pl-6">
          <v-btn
            icon
            class="close-icon"
            @click="newContact"
            :data-test-id="
              `${dataTestId}__add-contact-btn`
            "
          >
            <v-icon>add</v-icon>Add contact
          </v-btn>
        </v-row>
        <!-- <small>Add Contact</small> -->
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import UserService from '../../../services/UserService';
export default {
  components: {
    VueTelInput
  },
  data() {
    return {
      bindProps: {
        mode: 'international',
        defaultCountry: 'GB'
      },
      currentTab: 'tab-0',
      dialogTitle: 'Edit organization details',
      darkTheme: null,
      editContactDialog: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => this.emailValidate(v) || 'E-mail must be valid'
      ],
      contactForm: false,
      contacts: [
        {
          contactName: '',
          email: '',
          telePhone: ''
        },
        {
          contactName: '',
          email: '',
          telePhone: ''
        },
        {
          contactName: '',
          email: '',
          telePhone: ''
        }
      ],
      tabItems: [
        {
          id: 1,
          text: 'Front Desk'
        },
        {
          id: 2,
          text: 'Administrator'
        },
        {
          id: 3,
          text: 'Director'
        }
      ],
      telClass: '',
      dataTestId: 'contact-details-dialog'
    };
  },
  props: ['showDialog', 'orgDetails'],
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    this.editContactDialog = this.showDialog;
    this.contacts = JSON.parse(
      JSON.stringify(this.orgDetails.organisationContacts)
    );
  },
  methods: {
    validatePhoneNumber({ isValid }, index) {
      this.contacts?.[index] && (this.contacts[index].isValid = isValid);
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.editContactDialog) {
        this.closeDialog();
      }
    },
    removeContact(index) {
      this.contacts.splice(index, 1);
    },
    async getForm() {
      return this.$refs.form[0].validate();
    },
    newContact() {
      this.contacts.push({
        contactName: '',
        email: '',
        telePhone: ''
      });
      this.$nextTick(() => {
        this.currentTab = 'tab-' + (this.contacts.length - 1) + '';
      });
    },
    async updateContacts() {
      try {
        let contacts = this.contacts;
        let error = false;
        let filteredContacts = [];
        for (let index = 0; index < contacts.length; index++) {
          const contact = contacts[index];
          if (contact.contactName === '') {
            this.snackbar(
              'error',
              'Contact ' + (index + 1) + ' -Name cannot be blank'
            );
            error = true;
            break;
          } else if (
            contact.email === '' ||
            !this.emailValidate(contact.email)
          ) {
            this.snackbar(
              'error',
              'Contact ' + (index + 1) + ' -Email is not valid'
            );
            error = true;
            break;
          } else if (contact.telePhone === '' || !contact.isValid) {
            this.snackbar(
              'error',
              'Contact ' + (index + 1) + ' -Telephone is not valid'
            );
            error = true;
            break;
          } else {
            error = false;
            filteredContacts.push(contact);
          }
        }
        if (error) {
          return false;
        }
        let requestObj = {
          organisationContacts: filteredContacts
        };
        await UserService.updateOrg({
          orgId: this.orgDetails.orgId,
          obj: requestObj
        });
        this.snackbar('success', this.$message.UPDATE_SUCCESS);
        this.closeDialog();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    closeDialog() {
      this.editContactDialog = false;
      this.$emit('closeOverlay', true);
    },
    clearAll() {
      this.editDataContact = {};
      this.editContactDialog = false;
    }
  }
};
</script>

<style scoped>
.vue-tel-input:focus-within {
  box-shadow: none;
  border-color: transparent;
}
.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: #58e2c2;
}
span {
  font-size: 16px;
}
.v-btn:before {
  background: transparent !important;
}
.v-application .align-center {
  align-items: baseline !important;
}
</style>
